import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Home from "./landing-screen/home";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LandingLayout from "./layouts/LandingLayout";
import DashboardLayout from "./layouts/DashboardLayout";
import DashboardHome from "./dashboard/Home1";
import TermService from "./landing-screen/TermService";
import PrivacyPolicy from "./landing-screen/PrivacyPolicy";
import DeletePolicy from "./landing-screen/DeletePolicy";
import Register from "./landing-screen/Register";
import SurveyPageCallback from "./landing-screen/surveypage";
// import ProfileSurvey from "./dashboard/ProfileSurvey";
import PersonalDetails from "./dashboard/PersonalDetails";
import Transaction from "./dashboard/Transaction";
import Referral from "./dashboard/ReferralNew";
import SignOut from "./dashboard/SignOut";
import SurveyPage from "./dashboard/Survey";
import SurveyDetail from "./dashboard/SurveyDetail";
import { useSelector } from "react-redux";
import Earnings from "./dashboard/Passbook";
import Reward from "./dashboard/Reward";
// import Prescreener from "./dashboard/Prescreener";
import { useNavigate } from "react-router-dom";

import FeedbackPage from "./dashboard/Feedback";
import FeedbackSurveyDetail from "./dashboard/FeedbackSurveyDetail";

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedInres, setisLoggedInres] = useState(false);
  const authStatus = useSelector((state) => state.auth);
  const isLoggedIn = authStatus.isLoggedIn;
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authData = urlParams.get("authData");

    if (authData) {
      const parsedAuthData = JSON.parse(decodeURIComponent(authData));
      if (parsedAuthData?.is_success) {
        localStorage.setItem("user", JSON.stringify(parsedAuthData));
        const token = parsedAuthData?.data?.token;
        localStorage.setItem("token", JSON.stringify(token));
        setisLoggedInres(true);
        navigate("/dashboard");
      }
    } else {
      const storedAuthData = localStorage.getItem("user");
      const authDataObject = storedAuthData ? JSON.parse(storedAuthData) : null;

      if (authDataObject?.is_success) {
        setisLoggedInres(authDataObject?.is_success);
      } else {
        setisLoggedInres(isLoggedIn);
      }
    }

    setIsLoading(false);
  }, [isLoggedIn, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      {isLoggedInres ? (
        <>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<DashboardHome />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/feedback-survey/:surveyId" element={<FeedbackSurveyDetail />} />
            <Route path="/personal-details" element={<PersonalDetails />} />
            <Route path="/transaction" element={<Transaction />} />
            <Route path="/refer" element={<Referral />} />
            <Route path="/survey" element={<SurveyPage />} />
             <Route path="/survey/:surveyId" element={<SurveyDetail />} />
            <Route path="/passbook" element={<Earnings />} />
            <Route path="/reward" element={<Reward />} />
            <Route path="/sign-out" element={<SignOut />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
             <Route path="/survey-callback" element={<SurveyPageCallback />} />
          </Route>
          {/* <Route path="/pre-screener" element={<Prescreener />} /> */}
       
        </>
      ) : (
        <Route element={<LandingLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/term-service" element={<TermService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/delete-policy" element={<DeletePolicy />} />
          {/* <Route path="/survey-callback" element={<SurveyPageCallback />} /> */}
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      )}
    </Routes>
  );
}

export default App;
